import React from 'react';
import "./about.css";
import react1 from '../images/react1.jpg'
import react2 from '../images/react22.jpg'
import { Link } from 'react-router-dom';

const AboutComponent = () => {
  return (
    <div>
        <div className="about-container">
      <h1 className="about-heading">About Me</h1>
      <div className="about">
      <div className="left">
        <h1>Who I am</h1>
        <h6> I'm a frontend engineer. I used HTML5, CSS3, JavaScript, Reactjs, Bootstrap, Tailwind css and styled component. I have also expert in Social Media Marketing, Social Media Optimization, Facebook marketing, Instagram marketing.</h6>
        <Link to="/contact">
          <button className='contact-btn'>Contact</button>
        </Link>
      </div>
      <div className="right">
        <div className="img-container">
          <div className="img-stack top">
            <img src={react2} className="img" alt="" />
          </div>
          <div className="img-stack bottom">
            <img src={react1} className="img b-img" alt="" />
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
  )
}

export default AboutComponent;